import type {
    ScreenerEvent,
    ScreenerMarket,
} from '../../board/api/boardTypes';
import type { SearchEvent, SearchMarket } from '../api/searchTypes';
import { isDependent } from './marketOrder';

function toScreenerMarket(market: SearchMarket): ScreenerMarket {
    return {
        market_id: market.market_id,
        question: market.question,
        outcome_yes_label: market.group_item_title || null,
        outcome_no_label: market.outcome_no_label,
        yes_prob: market.yes_prob,
        live_prob: null,
        live_prob_at: null,
        volume: market.volume,
        volume_24h: null,
        closed: market.closed,
        resolved: market.resolved,
        is_open: market.is_open,
        open_signal_count: 0,
    };
}

function marketMode(event: SearchEvent): string {
    if (event.markets.length <= 1) return 'single';
    return isDependent(event.markets.filter(m => m.yes_prob != null))
        ? 'dependent'
        : 'independent';
}

export function searchEventPanel(event: SearchEvent): ScreenerEvent {
    return {
        event_id: event.event_id,
        title: event.title,
        slug: event.slug,
        image: event.image,
        category: event.category,
        tags: event.tags,
        created_at: event.created_at,
        start_date: event.start_date,
        end_date: event.end_date,
        resolution_status: event.status,
        volume: event.volume,
        volume_24h: null,
        market_count: event.market_count,
        open_market_count: event.open_market_count,
        market_mode: marketMode(event),
        open_signal_count: 0,
        markets: event.markets.map(toScreenerMarket),
        primary_market_id: event.primary_market_id,
        sort_value: event.sort_value,
    };
}
